module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/116ce29583ed1947092bef49fe88a273.svg";